export default [
    {
        name: 'name',
        title: 'Acte',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '25%'
    },
    {
        name: 'createdAt',
        title: 'Créé le',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '10%'
    },
    {
        name: 'beneficiary',
        title: 'Catégorie de bénéficiaires',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '10%'
    },
    {
        name: 'isSigned',
        title: 'Signé ?',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '10%'
    },
    {
        name: 'effectStartDate',
        title: 'Date d\'entrée en vigueur avant le',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '10%'
    },
    {
        name: 'resend',
        title: 'Relancer le signataire',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '15%'
    },
    {
        name: 'document',
        title: 'Télécharger',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '10%'
    },
    {
        name: 'status',
        title: 'Opposabilité',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '20%'
    },
    {
        name: 'actions',
        title: 'Actions',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '20%'
    }
];
